export default __webpack_public_path__ + "static/media/ChangeLastYearReference.ede3fbae.png";